import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpLoaderFactory } from 'app/app.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from 'app/shared/shared.module';
import { EncryptionService } from './services/column-encryption.service';
import { EncryptionEntityLogsComponent } from './encryption-entity-logs/encryption-entity-logs.component';
import { EncryptionComponent } from './encryption.component';
import { ColumnEncryptionKeyComponent } from './column-encryption-key/column-encryption-key.component';



@NgModule({
  declarations: [
    ColumnEncryptionKeyComponent,
    EncryptionEntityLogsComponent,
    EncryptionComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    SharedModule
  ],
  exports: [ EncryptionComponent ],
  providers: [EncryptionService],
})
export class EncryptionModule { }
